"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VmetaFieldType = void 0;
var VmetaFieldType;
(function (VmetaFieldType) {
    VmetaFieldType["String"] = "String";
    VmetaFieldType["Number"] = "Number";
    VmetaFieldType["Boolean"] = "Boolean";
    VmetaFieldType["Array"] = "Array";
    VmetaFieldType["Date"] = "Date";
    VmetaFieldType["Mixed"] = "Mixed";
    VmetaFieldType["ObjectId"] = "mongoose.Schema.ObjectId";
})(VmetaFieldType || (exports.VmetaFieldType = VmetaFieldType = {}));
